import { Icon } from '@toggle/design-system';
import React from 'react';

import * as S from './TopRankIcon.styles';

interface TopRankIconProps {
  rank?: number;
  iconSize?: number;
  limit?: number;
  rankFontSize?: number;
  rankTopPosition?: string;
}

export const TopRankIcon = ({
  rank,
  iconSize = 32,
  limit = 3,
  rankFontSize = 14,
  rankTopPosition = '14%',
}: TopRankIconProps) => {
  if (!rank) {
    return <S.StyledPlaceholder>-</S.StyledPlaceholder>;
  }

  if (rank <= limit) {
    return (
      <S.Wrapper>
        <S.StyledIconRank
          $fontSize={rankFontSize}
          $topPosition={rankTopPosition}
          data-testid="rank-icon"
        >
          {rank}
        </S.StyledIconRank>
        <Icon
          size={iconSize}
          iconName="Rank"
          fillColor={'var(--icon-default)'}
        />
      </S.Wrapper>
    );
  }

  return <S.StyledRank>{rank}</S.StyledRank>;
};
